import { Directive, ElementRef, Input, OnInit, SecurityContext, ViewContainerRef, Component, ViewChild, DoCheck, AfterViewInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as _ from 'lodash';

/**
 * How to use this directive.
 * 1. Import the DirectivesModule to the module of the component
 * 2. Use the directive to the element you want to add id
 * 3. The directive accepts 3 strings in an array as input. 1st is custom text, 2nd is custom element tag name, 3rd is custom component name
 * 
 * eg. escCustomId="status,txt,made_up_component"
 * eg. escCustomId="status" - uses auto generation of element tag name and component name
 * eg. escCustomId="status,txt" - uses auto generation of componenent name only 
 */

@Directive({
  selector: '[escCustomId]'
})
export class CustomIdDirective implements AfterViewInit,OnInit{

  @Input() escCustomId:Array<string> | string = Array<string>();

  constructor(
    private el:ElementRef,
    private sanitizer: DomSanitizer,
    private _view: ViewContainerRef) { }

  ngAfterViewInit(): void {
    let sanitizedEntry = this.sanitizer.sanitize(SecurityContext.HTML, this.escCustomId)
    
    let customIdProperties = sanitizedEntry.split(',')
    
    this.el.nativeElement.id = this.generateID(this.el, customIdProperties[0], customIdProperties[1], customIdProperties[2])

  }

  ngOnInit(): void {
    
  }

  generateID(element:ElementRef, customText:string, customTagName:string, componentName:string){
    let generatedComponentName = '';
    try {
      if(!componentName){
        generatedComponentName = this.getComponentName(this._view)
      } else {
        generatedComponentName = componentName
      }
    } catch (e) {
      console.log(e)
      generatedComponentName = componentName
    }

    // for debugging
    // let tagName = "div"
    // try {
    //   tagName = this.getTagNameAlias(element.nativeElement.tagName.toLowerCase());
    // } catch(e){
    //   console.log(e);
    //   console.log(element.nativeElement)
    // }

    let tagNameAlias = customTagName ? customTagName : this.getTagNameAlias(element.nativeElement.tagName.toLowerCase());

    let id = "id_" + 
      generatedComponentName + "_" +
      tagNameAlias + 
      ( customText ? "_" : "") + 
      customText 
    return id
  }

  /**
   * Add here common tagNames and their conversion
   * 
   * @param tagName 
   * @returns 
   */
  getTagNameAlias(tagName:string){
    switch (tagName){
      case "input":
        return "txt"

      case "span": 
      case "mat-label":
      case "mat-error":
      case "mat-card-title":
      case "mat-card-subtitle":
      case "mat-hint":
      case "h1":
      case "h2":
      case "h3":
      case "h4":
      case "h5":
      case "h6":
        return "lbl"

      case "button":
        return "btn"

      case "img":
      case "mat-icon":
        return "img"

      case "mat-option":
        return "option"

      case "mat-autocomplete":
        return "dropdown"

      case "mat-datepicker-toggle":
        return "toggle"

      case "th":
        return "th"

      case "td":
        return "td"

      case "mat-checkbox":
        return "check-box"

      case "mat-chip":
        return "chip"

      default:
        return "div"

    }
  }

  /**
   * This function is brittle and might be too dependent on the current structure
   * of the current Angular Version which is Angular 14.2.3.
   * 
   * Please check if the path still exist when upgrading Angular version.
   * @param vc 
   */
  getComponentName(vc:ViewContainerRef){

    // Embedded Views (mat-error)
    if(vc.injector['_lView'][0] === null){
      return vc.injector['_lView'][3][3][0].tagName.toLowerCase().replaceAll('-','_')
    
    // Component View
    } else if (vc.injector['_lView'][0]){
      return vc.injector['_lView'][0].tagName.toLowerCase().replaceAll('-','_')

    } else {
      throw new Error("ESC CUSTOM ID: Error getting component name. Have you updated the Angular version? Please provide a component name instead.")
    }
    
  }

}
